module.exports = __webpack_public_path__ + "static/media/welcome.fe167819.png";